import {
    ChangeDetectionStrategy,
    Component, EventEmitter,
    Input,
    OnInit, Output
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import {
    callScripts,
    PowernovaValueModel,
    soundSoundIdURL,
    soundTTSUrl
} from './powernova-value/powernova-value.model';

@Component({
    selector: 'powernova',
    templateUrl: './powernova.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PowernovaComponent implements OnInit {

    @Input() content;
    @Input() updatedModel;
    @Input() isOnlyPreview;
    @Input() contextVariables;
    @Input() communicationsCategoryId;
    @Output() readonly voiceChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() readonly selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();
    callScripts = {};
    powerNova: PowernovaValueModel[] = [];
    powerNovaValue: PowernovaValueModel[] = [];
    powerNovaValueVoiceMail = [];
    powerNovaValueLanguage = [];
    isPlaying = false;
    isVoiceMail = false;
    isPlayAll = false;
    subscription = new Subscription();
    playSequence = -1;
    containsMoreThanOneLanguage = false;
    selectedLanguage = 'EN';

    playAll(sequenceNumber): void {
        this.playSequence = 0;
        this.isPlayAll = true;
    }

    stop(): void {
        this.playSequence = -1;
        this.isPlayAll = false;
    }

    isEnded(): void {
        if (this.isPlayAll) {
            this.playSequence++;
            if (this.playSequence >= this.powerNova.length) {
                this.stop();
            }
        }
    }

    showVoiceMail(): void {
        this.isVoiceMail  =  !this.isVoiceMail;
        this.powerNova = this.isVoiceMail ? this.powerNovaValueVoiceMail : this.powerNovaValue;
    }

    changeLanguage(): void {
        this.selectedLanguage  =  this.selectedLanguage === 'EN' ? 'ES' : 'EN';
        this.powerNova = this.selectedLanguage === 'EN' ? this.powerNovaValue : this.powerNovaValueLanguage;
    }

    ngOnInit(): void {
        this.callScripts = {...callScripts};
        // const callScriptMatches = this.content.match(/(multiLanguage="([^"]|"")*")/g);
        this.containsMoreThanOneLanguage =  this.content.indexOf('ES') !== -1;
        // callScriptMatches !== 0 && callScriptMatches !== null;
        // NOTE: check if any other language (currently only for Spanish) so we dont need this
//        const language: Array = callScriptMatches[0]
//                                    .replace('multiLanguage="', '')
//                                    .replace('"', '')
//                                    .split('_');
        const handleScript = this.callScripts['handleScript'];
        this.setPowerNovaValues(handleScript);
    }

    setPowerNovaValues(handleScript): void {
        const matches = this.content.match(/(<PowerNovaValue[^>]*>)([^<]*|\n)*?(<\/PowerNovaValue>)/g);
        let i = 0;
        if (matches !== 0 && matches !== null) {
            while (i !== matches.length) {
                if (matches[i].indexOf('api_useConfirm') === -1 && matches[i].indexOf('api_autoConfirmVoicemail') === -1) {
                    const value: PowernovaValueModel = {
                        type: undefined,
                        soundId: undefined,
                        uiText: undefined,
                        model: undefined,
                        src: undefined,
                        name: undefined,
                        containsAppointment: '',
                        isAppointment: false,
                        audioService: undefined,
                        canPreview: false
                    };
                    value.type = matches[i].indexOf('tts') !== -1 ? 'tts' : 'audio';
                    value.name = this.extractValue('name', matches[i], /(name="([^"]|"")*")/g);
                    // Check for all languages
                    const selectedKey = Object.keys(handleScript)
                        .find(key => key === value.name || `${key}ES` === value.name);
                    if (selectedKey !== undefined) {
                        const selectedValue = handleScript[selectedKey];
                        if (selectedValue['isAppointment'] !== undefined) {
                            value.isAppointment = selectedValue['isAppointment'];
                        }
                        if (selectedValue['containsAppointment'] !== undefined) {
                            value.containsAppointment = selectedValue['containsAppointment'];
                        }
                        if (value.type !== selectedValue['type']) {
                            if (selectedValue['type'] === 'tts') {
                                value.type = 'tts';
                            }
                        }

                        if (value.type === 'tts') {
                            this.extractModelAndUiText(value, selectedValue);
                            const textToSpeech = this.extractContextVariable(value);
                            value.src = `${soundTTSUrl}${textToSpeech}`;
                            value.canPreview = true;
                        } else {
                            const soundId = this.extractValue('soundId', matches[i], /(soundId="([^"]|"")*")/g);
                            if (soundId.indexOf('template-context') !== -1) {
                                this.extractModelAndUiText(value, selectedValue);
                                value.soundId = this.extractContextVariable(value);
                                value.src = `${soundSoundIdURL}${value.soundId}`;
                            } else {
                                value.soundId = soundId;

                                if (value.soundId !== '0' && value.soundId !== '') {
                                    value.src = `${soundSoundIdURL}${value.soundId}`;
                                }
                                let uiText = '';
                                if (matches[i].indexOf('uiText') !== undefined) {
                                    uiText = this.extractValue('ui-text', matches[i], /(ui-text="([^"]|"")*")/g);
                                }
                                value.uiText = uiText !== '' ? uiText : selectedValue['uiText'];
                            }

                            if (soundId !== '') {
                                value.canPreview = true;
                            }
                        }
                        if (selectedValue['isForNormal'] && value.canPreview) {
                            if (value.name.indexOf('ES') === -1) {
                                this.powerNovaValue.push(value);
                                if (value.name === 'companyIntro' ||
                                    value.name === 'companyIntro2' ||
                                    value.name === 'press1spanish') {
                                    this.powerNovaValueLanguage.push(value);
                                }
                            } else {
                                this.powerNovaValueLanguage.push(value);
                            }
                        }
                        if (selectedValue['isForVoicemail'] && value.canPreview) {
                            this.powerNovaValueVoiceMail.push(value);
                        }
                    }
                }
                i++;
            }
        }

        this.powerNova = this.powerNovaValue;
    }

    extractValue(key, value, regex): string {
        const match = value.match(regex);
        if (match !== null) {
            return match[0]
                .replace(`${key}="`, '')
                .replace('"', '');
        }

        return '';
    }

    extractModelAndUiText(value, selectedValue): any {
        Object.entries(this.updatedModel).map( (model:any) => {

            if (this.communicationsCategoryId === 'reminder') {
                const contains2 = model[0].indexOf('2') !== -1; // this is to check cases like regarding2
                if (model[0].toLowerCase().indexOf(value.name.toLowerCase()) !== -1) {
                    if (!contains2) {
                        value.model = selectedValue['model'] !== undefined ? selectedValue['model'] : 'template.' + model[0];
                        value.uiText = model[1];
                    } else {
                        if (value.name.indexOf('2') !== -1) {
                            value.model = selectedValue['model'] !== undefined ? selectedValue['model'] : 'template.' + model[0];
                            value.uiText = model[1];
                        }
                    }
                }
            } else {
                if (model[0].toLowerCase() === 'voicemessage') {
                    value.model = selectedValue['model'] !== undefined ? selectedValue['model'] : 'template.' + model[0];
                    value.uiText = model[1];
                }
            }
        });

        // case when the selected voice tag is not present in updatedmodel
        if (value.model === undefined && selectedValue['model'] !== undefined) {
            value.model = selectedValue['model'];
            value.uiText = '';
        }

        return value;
    }

    extractContextVariable(value): any {
        let contextVariableValue = undefined;
        Object.entries(this.contextVariables).map(variable => {
            if (this.communicationsCategoryId === 'reminder') {
                const contains2 = variable[0].indexOf('2') !== -1; // this is to check cases like regarding2
                if (variable[0].toLowerCase().indexOf(value.name.toLowerCase()) !== -1) {
                    if (!contains2) {
                        contextVariableValue = variable[1];
                    } else {
                        if (value.name.indexOf('2') !== -1) {
                            contextVariableValue = variable[1];
                        }
                    }
                }
            } else {
                if (variable[0] === 'voiceMessage') {
                    contextVariableValue = variable[1];
                }
            }
        });

        return contextVariableValue;
    }
}
